module.exports = __webpack_public_path__ + "media/icons/clock-e6770a32.svg";